import RoundInspectionModule from '../../components/common/RoundInspection/RoundInspectionModule';
import CommunicationModule from '../../components/common/Communication/CommunicationModule';
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import ProtectedRoute from "./ProtectedRoute";
import LoginFlow from "../../components/pages/login/LoginFlow";
import NotFound from "../../components/pages/error/NotFound";
import WalkInVisitorRequest from "../../components/pages/commercial/VisitorsManagment/walkinVisitor/WalkInVisitorRequest";
import WalkInVisitorPass from "../../components/pages/commercial/VisitorsManagment/walkinVisitor/walkinwebFlow/WalkInVisitorPass";
import VisitorPass from "../../components/pages/commercial/VisitorsManagment/visitorpass/VisitorPass";
import { commercialRoutes } from "./modules/commercialRoutes";
import { residentialRoutes } from "./modules/residentialRoutes";
import { commonRoutes } from "./modules/commonRoutes";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginFlow />} />
      <Route path="/vendor-login" element={<LoginFlow />} />
      <Route path="/zentech-login" element={<LoginFlow />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="/check-in" element={<WalkInVisitorRequest />} />
      <Route path="/check-in-pass" element={<WalkInVisitorPass />} />
      <Route path="/qr-code-pass" element={<VisitorPass />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          
          {/* Mount Commercial Module */}
          <Route path="/zentcomm">
            <Route index element={<Navigate to="dashboard" replace />} />
            {commercialRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
          </Route>

          {/* Mount Residential Module */}
          <Route path="/zentres">
            <Route index element={<Navigate to="dashboard" replace />} />
            {residentialRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
          </Route>

                    {/* Direct root routes for Round & Inspection */}
          <Route path="/round-inspection" element={<RoundInspectionModule />} />
          <Route path="/round-inspection/*" element={<RoundInspectionModule />} />
          <Route path="/communication" element={<CommunicationModule />} />
          <Route path="/communication/*" element={<CommunicationModule />} />

          {/* Mount Common/Shared Module */}
          <Route path="/common">
            <Route index element={<Navigate to="my-rules" replace />} />
            {commonRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
          </Route>

        </Route>
      </Route>
      {/* Catch-all route for any undefined paths */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRouter;